var map = {
	"./decidim/avatar-multiuser.png": 73980,
	"./decidim/brands/facebook.svg": 59154,
	"./decidim/brands/google.svg": 50707,
	"./decidim/brands/twitter-x.svg": 30608,
	"./decidim/cc-badge.png": 51662,
	"./decidim/decidim-logo.svg": 23230,
	"./decidim/default-avatar.svg": 23786,
	"./decidim/gamification/badges/decidim_gamification_badges_followers.svg": 73534,
	"./decidim/icons.svg": 86877,
	"./decidim/pattern.png": 6906,
	"./decidim/placeholder-card-g.svg": 53527,
	"./decidim/placeholder-card-l.svg": 82316,
	"./decidim/placeholder.jpg": 14899,
	"./decidim/remixicon.symbol.svg": 33307,
	"./decidim/vendor/social-share-button/douban.svg": 17066,
	"./decidim/vendor/social-share-button/email.svg": 58183,
	"./decidim/vendor/social-share-button/facebook.svg": 19257,
	"./decidim/vendor/social-share-button/google_bookmark.svg": 47227,
	"./decidim/vendor/social-share-button/hacker_news.svg": 51851,
	"./decidim/vendor/social-share-button/linkedin.svg": 1175,
	"./decidim/vendor/social-share-button/odnoklassniki.svg": 41040,
	"./decidim/vendor/social-share-button/pinterest.svg": 2153,
	"./decidim/vendor/social-share-button/reddit.svg": 60281,
	"./decidim/vendor/social-share-button/telegram.svg": 40608,
	"./decidim/vendor/social-share-button/tumblr.svg": 88727,
	"./decidim/vendor/social-share-button/twitter.svg": 26582,
	"./decidim/vendor/social-share-button/vkontakte.svg": 25672,
	"./decidim/vendor/social-share-button/wechat.svg": 95411,
	"./decidim/vendor/social-share-button/whatsapp.svg": 54763,
	"./decidim/vendor/social-share-button/x.svg": 39903,
	"./decidim/vendor/social-share-button/xing.svg": 52537
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;